import React from "react";
import useTitanApp from "../../../hooks/useTitanApp";
import { setShowVaccinationPreviewModal } from "../../../dispatchers/patientDispatchers";
import { Modal, Box, IconButton, Button } from "@mui/material";
import { IoClose } from "react-icons/io5";

export default function VaccinationPreviewModal() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { showVaccinationPreviewModal, vaccinationImageBase64 } =
    patientState || {};

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: darkMode ? "#222" : "#fff",
    boxShadow: 24,
    borderRadius: "16px",
  };

  const handleCloseModal = () => {
    setShowVaccinationPreviewModal(false);
  };

  const handleDownload = () => {
    // 1. Create a hidden anchor tag
    const link = document.createElement("a");
    link.href = vaccinationImageBase64;
    link.download = "vaccination-certificate";
    // 2. Attach, click, and clean up
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal open={showVaccinationPreviewModal}>
      <Box sx={style}>
        <div className="pc-actions-modal-wrapper prescription-preview vaccination-preview-image">
          <div className="pc-actions-modal-header">
            <h3></h3>
            <IoClose
              className="close-icon"
              onClick={handleCloseModal}
              color={darkMode ? "#f2f2f2" : "#222"}
            />
          </div>
          <div className="vc-actions-modal-content">
            <img
              src={vaccinationImageBase64}
              alt="Vaccination Preview"
              className="preview-image"
            />
          </div>
          <div className="download-button">
            <Button
              variant="contained"
              size="small"
              onClick={handleDownload}
              className="download-btn"
            >
              Download
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
